export const isString = (x: unknown): x is string =>
  typeof x === 'string' || x instanceof String

export const isArray = (x: unknown): x is any[] => Array.isArray(x)
